// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1Ja_w","obliqueLineWrap":"membershipbadge_obliqueLineWrap__lXBvy","obliqueLine":"membershipbadge_obliqueLine__2qSxo"};